import * as S from "./styles"

import { FaWhatsapp } from 'react-icons/fa'

export default function WhatsApp() {
    return(
        <S.IconWhatsapp>
            <FaWhatsapp />
        </S.IconWhatsapp>
    )
}